export default "__VITE_ASSET__e52d8521__"